import { forwardRef, memo } from 'react'

export function createComponent<T, P>(
  component: (props: P, ref: React.Ref<T>) => React.ReactElement | null,
  displayName: string,
  options: { shouldMemoize?: boolean } = {},
):
  | React.ForwardRefExoticComponent<React.PropsWithoutRef<P> & React.RefAttributes<T>>
  | React.MemoExoticComponent<React.ForwardRefExoticComponent<React.PropsWithoutRef<P> & React.RefAttributes<T>>> {
  let ForwardRefComponent = forwardRef<T, P>(component as any)

  if (options.shouldMemoize) {
    const MemoizedComponent = memo(ForwardRefComponent)
    MemoizedComponent.displayName = displayName
    return MemoizedComponent
  }

  ForwardRefComponent.displayName = displayName
  return ForwardRefComponent
}
